import { useEffect, useRef } from "react";

export function useRecipientsChanged(callback: () => void) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    let item: typeof Office.context.mailbox.item | undefined;
    let handler: ((args?: any) => void) | undefined;
    let isHandlerAdded = false;
    let isUnmounted = false;

    Office.onReady(() => {
      item = Office.context?.mailbox?.item;
      
      if (!Office.context?.requirements?.isSetSupported?.("Mailbox", "1.7")
        || item?.itemType !== Office.MailboxEnums.ItemType.Message) {
        return;
      }

      handler = (args?: any) => {
        callbackRef.current();
        args && args.completed && args.completed();
      };

      item.addHandlerAsync(Office.EventType.RecipientsChanged, handler, (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          isHandlerAdded = true;
          if (isUnmounted && item && handler) {
            item.removeHandlerAsync(Office.EventType.RecipientsChanged, handler);
          }
        }
      });
    });

    return () => {
      isUnmounted = true;
      if (isHandlerAdded && item && handler) {
        item.removeHandlerAsync(Office.EventType.RecipientsChanged, handler);
      }
    };
  }, []);
}